module.exports = __webpack_public_path__ + "static/img/slide_1_2.400ccbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcimages/slide_1_2.png
// module id = Gs99
// module chunks = 51